import moment from 'moment-timezone';
import { BillingStatus, OptionCode } from '../../enums';
import { ApplicableTo, ReleaseStatus } from '../options';
import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
import { mockedPlotOptionActivation } from './plotOptionActivations';
export const mockedReseller = {
    name: 'Weenat',
    contact: 'contact@weenat.com'
};
export const mockedOption = {
    id: 1,
    applicableTo: [ApplicableTo.plot],
    billingStatusAvailability: BillingStatus.plus,
    approvalsCount: 2,
    code: OptionCode.weephyt,
    price: null,
    isChargeable: false,
    reseller: mockedReseller,
    releaseStatus: ReleaseStatus.public,
    createdAt: moment('2020-01-01').unix().toString(),
    mandatoryMetricsIds: ['T'],
    numberOfGrantedPlotActivationsPerPurchase: 1,
    numberOfGrantedSmsPerPurchase: 25,
    organizationOptionActivationsCount: 6,
    remainingTokens: 0,
    unusedOptionActivationApprovalRequestsCount: 4,
    name: 'Mocked Weephyt option',
    usage: 'Mocked Weephyt option usage',
    allowVirtualDevices: true
};
export const mockedPaginatedOptions = mockedPaginatedResponse([mockedOption]);
const mock = {
    activate: mockedRequester(mockedPlotOptionActivation, 'options.activate'),
    catalogue: mockedRequester([mockedOption], 'options.catalogue'),
    get: mockedRequester(mockedOption, 'options.get'),
    getMany: mockedRequester(mockedPaginatedOptions, 'options.getMany'),
    getPage: mockedRequester(mockedPaginatedOptions, 'options.getPage'),
    requestActivation: mockedRequester(undefined, 'options.requestActivation')
};
export default mock;
